var _rect, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Uruguay flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0038A8"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 24,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 24,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 24,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 24,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 24,
    height: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 4.6,
    r: 2,
    fill: "#FCD116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/uy.95f076f0069b6942f020503c6117b030.svg";
export { ForwardRef as ReactComponent };